<template>
    <div class="popup popup-rule" id="opbkRuleModal" :class="{ 'modal-in': isShow, 'modal-out': !isShow}"  style="display: block;">
        <div class="shorexDetail-title js-returnShorexBtn">
            <p>活动规则</p>
            <a class="shorexDetail-returnButton" @click="onGoBack()">
                <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightBlack.png">
            </a>
        </div>
        <div class="ruleDetail">
            <div class="packageRuleDetail">
                <div class="rule-item">
                    <div class="stateroomDetail-ruleCon rule-item-text">
                        <div class="reservation_desc" v-html="rule">

                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "OpenBookingRulePopup",
    props: {
        rule: {
            type: String
        },
        isShow: {
            type: Boolean
        },
        onGoBack: {
            type: Function
        }
    }
}
</script>

<style lang="less" scoped>
#opbkRuleModal.popup {
    position: fixed;
    background-color: #F6F7F8;
    transform: translate3d(100%, 0, 0);
    display: block;
    z-index: 10401;
}
#opbkRuleModal.modal-in {
    position: fixed;
    background-color: #F6F7F8;
    transform: translate3d(0, 0, 0);
}
#opbkRuleModal.modal-out {
    transform: translate3d(100%, 0, 0);
}

#opbkRuleModal {
    .shorexDetail-title {
        padding: 15px 20px;
        background-color: #fff;
        overflow: hidden;
        text-align: center;
        margin-bottom: 10px;
        position: fixed;
        width: 100%;
        z-index: 10;
        > p {
            
            font-size: 14px;
            color: #333333;
            letter-spacing: 1px;
            text-align: center;
            margin: 0;
        }
        .shorexDetail-returnButton {
            width: 30px;
            position: absolute;
            top: 15px;
            left: 20px;
            text-align: left;
            img {
                width: 33%;
            }
        }
    }
    .ruleDetail {
        padding-top: 50px;
        height: 100%;
        overflow: scroll;
        padding-bottom: 60px;
    }

    .rule-item {
        padding: 0 20px 12px;
        font-size: 12px;
        line-height: 20px;
        color: #666;
        letter-spacing: 0;
        background-color: #fff;
        .stateroomDetail-ruleCon {
            padding-top: 15px;
            .reservation_desc {
                color: #808080;
                font-size: 12px;
            }
        }
    }

    .rule-item:last-child {
        margin-bottom: 0;
    }

}
</style>

<style lang="less">
#opbkRuleModal .rule-item .rule-item-text p {
    margin: 0px;
}
</style>
